import { createSlice } from "@reduxjs/toolkit";
import { InitialStickerStockFormData } from "../../ConstantData/InitialData";
import { InitialStickerStockDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const stickerStockSlice = createSlice({
  name: "stickerstock",
  initialState: {
    stickerStockList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    billList: [],
    // billDataList: {},
    initialData: InitialStickerStockFormData,
    // initialDuplicateData: InitialStickerStockDuplicateFormData,
  },
  reducers: {
    getAllStickerStocks: (state, action) => {
      state.stickerStockList = action.payload;
    },
    getStickerStockDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialStickerStockFormData };
    },
    // setDuplicateInitialData: (state) => {
    //   state.initialDuplicateData = { ...InitialStickerStockDuplicateFormData };
    // },
    getBillList: (state, action) => {
      if (action.payload.data.length <= 0) {
        state.initialDuplicateData = [];
      }
      state.billList = action.payload.data;
    },
    getDataUsingBill: (state, action) => {
      state.initialDuplicateData = action.payload.data;
      state.dataEdit = action.payload.editData;
    },
    adjustStickerStockItem: (state, action) => {},
    deleteStickerStock: () => {},
  },
});

export const stickerStockSliceAction = stickerStockSlice.actions;
export default stickerStockSlice.reducer;
